import React from 'react';
import Simple from '../../../components/Layout/Simple';
import ConfirmEmailContent from '../../../components/Pages/Auth/ConfirmEmail';

export default function ConfirmEmail({ ...props }): JSX.Element {
  document.title = `${process.env.REACT_APP_TITLE}: Email confirmed successfully`;

  return (
    <Simple>
      <ConfirmEmailContent {...props} />
    </Simple>
  );
}
